import type {
  PermissionMapping,
  PermissionsListResponse,
} from "@eai-toolkit/client";
import { PermissionsApi } from "@eai-toolkit/client";

import { baseApi, handleQueryError } from "./baseApi";
import type { ResourceType } from "./resourceTypes";
import { axiosInstance } from "./utils";

const permissionsApi = new PermissionsApi(undefined, undefined, axiosInstance);

export const permissionsApiSlice = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPermissionsList: builder.query<PermissionsListResponse, void>({
      queryFn: async () => {
        try {
          const response = await permissionsApi.v1PermissionsList();
          return { data: response.data };
        } catch (error) {
          return handleQueryError(error);
        }
      },
    }),

    getPermissionsByResourceType: builder.query<
      PermissionMapping[],
      { resourceType: ResourceType }
    >({
      queryFn: async ({ resourceType }) => {
        try {
          const response = await permissionsApi.v1PermissionsGetByResourceType({
            resourceType,
          });
          return { data: response.data };
        } catch (error) {
          return handleQueryError(error);
        }
      },
    }),
  }),
});

export const {
  useGetPermissionsListQuery,
  useGetPermissionsByResourceTypeQuery,
} = permissionsApiSlice;
